import white from './light';
import dark from './dark';

export const themes = {
	dark,
	white,
};

export default themes;
